// extracted by mini-css-extract-plugin
export default {"mainView":"MainView_mainView__uz2Vd","fieldDefGrid":"MainView_fieldDefGrid__pDj2-"};